// Dummy class necessary to give `babel-transform-custom-element-classes`
// something to operate on, producing es5-compatible code.
export class _HTMLElement extends HTMLElement {}

export const HAS_SHADY_CSS = window.hasOwnProperty('ShadyCSS');

export function createTemplate(html) {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template;
}

/**
 *
 * @param {String[]} props A list of property names.
 * @param {Function} [sourceFn] A function that accepts a property name and
 * returns a value.
 * @returns {Object} Object with a key for each property name and value
 * corresponding to result of passing the property name to `sourceFn`.
 *
 * @ignore (Hide from generated docs)
 */
export function initializeProps(props, sourceFn) {
  return props.reduce(
    (_props, prop) => ({ ..._props, [prop]: sourceFn(prop) }),
    {}
  );
}

export function fromAttributeValue(type) {
  return (value) => {
    if (type !== 'boolean' && value === null) {
      return null;
    }

    switch (type) {
      case 'boolean':
        return fromBooleanAttributeValue(value);

      case 'number':
        return parseFloat(value);

      case 'string':
        return value;

      default:
        throw new Error(
          '`fromAttributeValue:` type must be one of `boolean`, `number` and `string`'
        );
    }
  };
}

export function toAttributeValue(type) {
  return (value) => {
    if (value === null) {
      return null;
    }

    switch (type) {
      case 'boolean':
        return toBooleanAttributeValue(value);

      case 'number':
      case 'string':
        return String(value);

      default:
        throw new Error(
          '`fromAttributeValue:` type must be one of `boolean`, `number` and `string`'
        );
    }
  };
}

function fromBooleanAttributeValue(value) {
  if (value === '') {
    return true;
  } if (value === null) {
    return false;
  } 
    return value;
  
}

export function toBooleanAttributeValue(value) {
  if (value === true) {
    return '';
  } if (value === false) {
    return null;
  } 
    return value;
  
}

export function applyAttribute(element, name, value) {
  // `null` represents the absence of an attribute
  value !== null
    ? element.setAttribute(name, value)
    : element.removeAttribute(name);
}

/**
 * Apply properties to an element as attributes. Useful when forwarding
 * attributes to another element.
 *
 * @param element An HTML element to apply attributes to
 * @param props Object with key/value pairs for each attribute to set.
 */
export function applyAsAttributes(element, props) {
  Object.keys(props).forEach((name) => {
    // Automatically translate boolean values to boolean attributes.
    const attrVal = toBooleanAttributeValue(props[name]);
    applyAttribute(element, name, attrVal);
  });
}

/**
 * Allows for easy explicit upgrading of properties that aren't already being
 * upgraded by being in `props` or `reflectedAttributes`.
 *
 * See [this post about lazy properties for why you want
 * this](https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties)
 *
 *
 * @param obj The instance the property is set on.
 * @param propName The name of the property to upgrade.
 */
export function upgradeProperty(obj, prop) {
  if (obj.hasOwnProperty(prop)) {
    const value = onj[prop];
    delete obj[prop];
    obj[prop] = value;
  }
}

export const kebabToCamelCase = (string) =>
  string.replace(/(-[a-z])/g, (letters) => letters[1].toUpperCase());
